// src/components/HouseholdSetup.js
import { useState } from "react";
import { useAuth } from "../AuthContext";
import { createHousehold } from "../householdService";

export default function HouseholdSetup({ onComplete }) {
 const { user } = useAuth();
 const [name, setName] = useState("");
 const [loading, setLoading] = useState(false);
 const [error, setError] = useState("");

 async function handleCreate(e) {
 e.preventDefault();
 if (!name.trim()) return;
 setLoading(true);
 setError("");
 try {
 const household = await createHousehold(user, name.trim());
 onComplete(household);
 } catch (err) {
 setError("Something went wrong. Please try again.");
 console.error(err);
 } finally {
 setLoading(false);
 }
 }

 return (
 <div style={styles.page}>
 <div style={styles.card}>
 <div style={{ textAlign: "center", marginBottom: 28 }}>
 <div style={{ fontSize: 56, marginBottom: 10 }}></div>
 <h2 style={styles.title}>Set Up Your Household</h2>
 <p style={styles.subtitle}>Give your household a name so family members can recognize it when you invite them.</p>
 </div>

 <form onSubmit={handleCreate}>
 <label style={styles.label}>Household Name</label>
 <input
 style={styles.input}
 placeholder='e.g. "The Johnson House" or "123 Maple St"'
 value={name}
 onChange={e => setName(e.target.value)}
 required
 autoFocus
 />

 {error && <div style={styles.error}>{error}</div>}

 <button style={styles.btn} type="submit" disabled={loading || !name.trim()}>
 {loading ? "Creating..." : "Create Household"}
 </button>
 </form>

 <div style={styles.hint}>
 <strong>Already have an invite?</strong> Sign out, check your email for the invite link, and click it to join an existing household instead.
 </div>
 </div>
 </div>
 );
}

const styles = {
 page: {
 minHeight: "100vh", background: "#fdf6ec",
 display: "flex", alignItems: "center", justifyContent: "center", padding: 20,
 fontFamily: "'Nunito', sans-serif",
 },
 card: {
 background: "white", borderRadius: 24, padding: "40px 36px",
 width: "100%", maxWidth: 460,
 boxShadow: "0 8px 32px rgba(139,69,19,0.15)",
 },
 title: { fontFamily: "'Fredoka One', cursive", fontSize: 28, color: "#8B4513", marginBottom: 8 },
 subtitle: { fontSize: 14, color: "#a07850", fontWeight: 600, lineHeight: 1.6 },
 label: {
 display: "block", fontFamily: "'Nunito', sans-serif", fontSize: 12,
 fontWeight: 800, letterSpacing: "0.08em", textTransform: "uppercase",
 color: "#a07850", marginBottom: 8,
 },
 input: {
 width: "100%", padding: "12px 14px", border: "2px solid #e8d5b8",
 borderRadius: 10, fontFamily: "'Nunito', sans-serif", fontSize: 15,
 fontWeight: 600, color: "#2c1810", background: "#fffaf4",
 outline: "none", boxSizing: "border-box", marginBottom: 16,
 },
 btn: {
 width: "100%", padding: "13px", border: "none",
 background: "linear-gradient(135deg, #ff8c00, #f97316)",
 borderRadius: 12, color: "white", fontFamily: "'Nunito', sans-serif",
 fontSize: 16, fontWeight: 800, cursor: "pointer",
 boxShadow: "0 4px 14px rgba(249,115,22,0.35)", transition: "all 0.18s",
 },
 error: {
 background: "#fee2e2", border: "1px solid #fecaca", color: "#dc2626",
 borderRadius: 10, padding: "10px 14px", fontSize: 13, fontWeight: 700, marginBottom: 14,
 },
 hint: {
 marginTop: 20, padding: "14px 16px", background: "#fff7ed",
 borderRadius: 12, border: "1px solid #fed7aa",
 fontSize: 13, color: "#92400e", fontWeight: 600, lineHeight: 1.6,
 },
};
